import axios from 'axios';

const vueAxios = {
    install(Vue, options) {
        const hostname = `${location.protocol}//${location.hostname}${location.port ? ':'+location.port: ''}`;

        axios.defaults.baseURL = `${hostname}/api`;
        Vue.prototype.$axios = axios;
    }
};

export default vueAxios;